import { TPersonalDataApplicationsStore } from '../types.ts';
import { PayloadAction } from '@reduxjs/toolkit';
import { TApplicationsPublicLinkResponse } from '~/store/types.ts';

export const personalDataApplicationsSubmitFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TApplicationsPublicLinkResponse>
) => {
  state.publicLink = action.payload.publicLink;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const personalDataApplicationsSubmitPending = (state: TPersonalDataApplicationsStore) => {
  state.loading = true;
  state.publicLink = '';
};
